export const table_titles = [
	{ name: "#", size: 10, order: "" },
	{ name: "Nombre", size: 50, order: "name" },
	{ name: "Acción", size: 10, order: "" },
];

export const base_list = {
	page: 1,
	paginate: 10,
	order: "name",
	orderType: "desc",
};

export const base_element = {
	id: "",
	name: "",
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};
